import type { ReactNode } from "react";

const FuelOptimizerLayout = ({ leftPanel, map }: { leftPanel: ReactNode; map: ReactNode }) => {
  return (
    <div className="flex flex-col lg:flex-row h-full">
      <div className="w-full lg:max-w-xs lg:h-full shadow-sm">{leftPanel}</div>
      <div className="flex-1 lg:h-full">
        <div className="h-full">{map}</div>
      </div>
    </div>
  );
};

export default FuelOptimizerLayout;
